import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

export default class ExcelUtils {
  static loadExcel(file: File, onLoad: (data: any[]) => any) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function(e) {
      if (e.target) {
        const data = e.target.result;
        const workbook = XLSX.read(data, {type: 'array', raw: true});
        let sheetContent: string[][] = [];
        const result: any[] = [];

        // 第一个 sheet
        if (workbook.SheetNames.length == 0) {
          throw new Error('Excel文件中没有Sheet');
        }
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        sheetContent = XLSX.utils.sheet_to_json(worksheet, {header: 1});

        // 最后一个 sheet
        // workbook.SheetNames.forEach((sheetName) => {
        //   const worksheet = workbook.Sheets[sheetName];
        //   sheetContent = XLSX.utils.sheet_to_json(worksheet, {header: 1});
        // });
        const header = sheetContent[0];
        for (let i = 1; i < sheetContent.length; i++) {
          const row = sheetContent[i];
          const order: any = {};
          const isEmpty = row.every(cell => !cell);
          if (isEmpty) continue;
          for (let j = 0; j < header.length; j++) {
            order[header[j]] = row[j];
          }
          result.push(order);
        }
        onLoad(result);
      }
    };
  }
}

class ExcelDateHelper {
  static toJSDate(serial: number) {
    const d = new Date(-2209075200000 + (serial - (serial < 61 ? 0 : 1)) * 86400000);
    return d;
  }
}
export function parseExcelDate(date: any) {
  if (typeof date === 'string') {
    if (dayjs(date).isValid()) {
      return dayjs(date).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }
  if (typeof date === 'number') {
    return dayjs(ExcelDateHelper.toJSDate(date)).format('YYYY-MM-DD');
  }
  return '';
}
